export default __webpack_public_path__ + "media/images/admin/close-36412103906516b661e4a969a2709f9c.svg";